import { matchesCnpjSearch } from 'src/utils/document';

export interface InstitutionKeywordMatch {
  name?: string;
  cnpj?: string;
}

export function institutionMatchesKeyword(
  institution: InstitutionKeywordMatch,
  keyword?: string,
) {
  if (!keyword) return true;

  return (
    !!institution.name?.toUpperCase().includes(keyword.toUpperCase()) ||
    matchesCnpjSearch(institution.cnpj, keyword)
  );
}
